@if(type === 'plddt'){
<div class="plddt-legends">
    <div class="very-low-parent">
        <div class="very-low">Very low</div>
        <div class="low">Low</div>
        <div class="high">High</div>
        <div class="very-high">Very high</div>
    </div>
    <div class="plddt-linear-legends">
    </div>
    <div class="scale">
        <div class="div">0</div>
        <div class="div">10</div>
        <div class="div">20</div>
        <div class="div">30</div>
        <div class="div">40</div>
        <div class="div">50</div>
        <div class="div">60</div>
        <div class="div">70</div>
        <div class="div">80</div>
        <div class="div">90</div>
        <div class="div">100</div>
    </div>
</div>
}
@if(type === 'missense'){
<div class="missense-legends">
    <div class="misseens-group">
        <div class="benign-parent">
            <div class="benign">Benign</div>
            <div class="uncertain">Uncertain</div>
            <div class="pathogenic">Pathogenic</div>
        </div>
        <div class="missense-linear-legends">
        </div>
        <div class="scale2">
            <div class="div2">0.0</div>
            <div class="div2">0.2</div>
            <div class="div2">0.3</div>
            <div class="div2">0.4</div>
            <div class="div2">0.5</div>
            <div class="div2">0.6</div>
            <div class="div2">0.7</div>
            <div class="div2">0.8</div>
            <div class="div2">1.0</div>
        </div>
    </div>
</div>

}